import { faCompass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';

const PageNotFound = () => {
  return (
    <div style={styles.container}>
      <FontAwesomeIcon icon={faCompass} style={styles.icon} />
      <h1 style={styles.heading}>Oops! Lost Your Way?</h1>
      <p style={styles.message}>
        It seems the page you're looking for is off the map.
      </p>
      <a href="/" style={styles.link}>
        TAKE ME HOME
      </a>
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  container: {
    textAlign: 'center',
    marginTop: '80px', // Default margin
    paddingBottom: '100px', // Default padding
    fontFamily: 'Arial, sans-serif',
    color: '#333',
  },
  icon: {
    fontSize: '50px',
    color: '#ff6f61',
    marginBottom: '15px',
  },
  heading: {
    fontSize: '36px',
    fontWeight: 'bold',
    margin: '10px 0',
  },
  message: {
    fontSize: '16px',
    margin: '10px 0 15px',
  },
  link: {
    fontSize: '14px',
    color: '#007bff',
    textDecoration: 'underline',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
  },
};

export default PageNotFound;
